import React , { Component } from 'react';
import PropTypes from 'prop-types';
import {injectIntl} from 'react-intl';

import MapsChart from './charts/MapsChart';

import Logo from '../resources/images/logo.png';

const exportImageConfiguration = {
  'image.small':{width:640,height:480},
  'image.medium':{width:1024,height:768},
  'image.large':{width:1920,height:1080},
};

class Chart extends Component {

  constructor(props) {
    super(props);

    this.export = this.export.bind(this);
    this.getSvg = this.getSvg.bind(this);
    this.resetTitle = this.resetTitle.bind(this);
    this.state = {
      chartKind: this.props.chartKind,
      _keyId: this.props.chartKey,
      config: this.props.config
    }
  }



  resetTitle() {
    this.setTitle(null,null);
  }

  setTitle(title, subtitle) {
    let implChart = this.refs['chartRef'].getWrappedInstance();
    implChart.getChart().setTitle({text:title}, {text:subtitle});

  }

  getSvg(title,drilldownValue) {
    let implChart = this.refs['chartRef'].getWrappedInstance();
    implChart.getChart().setTitle({style:{color:'gray' , fontFamily:'"Open Sans", OpenSans, sans-serif', fontWeight:200, fontSize:'12pt'}});
    implChart.getChart().setTitle({text:title });
    implChart.getChart().setTitle({style:{color:'gray'}});
    implChart.getChart().setTitle(null,{text:drilldownValue});
    //console.dir(implChart);
    return implChart.getChart().getSVG({

      sourceWidth:1280,
      sourceHeight:800
    });

  }

  export(title, drilldownValue, kind, filename, sizeOption) {

    let implChart = this.refs['chartRef'].refs.wrappedInstance;
    implChart.getChart().setTitle({style:{color:'gray' , fontFamily:'"Open Sans", OpenSans, sans-serif', fontWeight:200, fontSize:'12pt'}});
    implChart.getChart().setTitle({text:title });
    implChart.getChart().setTitle({style:{color:'gray'}});
    implChart.getChart().setTitle(null,{text:drilldownValue});

    var exportChartOptions = {chart: {events: {
      load: function() {
        this.renderer.image(Logo,
          exportImageConfiguration[sizeOption].width-108, exportImageConfiguration[sizeOption].height-35, 108, 35)
        .add();
      }
}}};

    implChart.getChart().exportChartLocal({
      sourceWidth: exportImageConfiguration[sizeOption].width,
      sourceHeight: exportImageConfiguration[sizeOption].height,
      scale:1,
      type: kind,
      filename:  filename
    }, exportChartOptions);

  }

  render() {
    const {formatMessage} = this.props.intl;

    const {config} = this.props;
    const {hide} = this.props;

    let that = this;
    config.plotOptions.column.point.events.click= function (event) {
      that.props.handleDrillDown( this.category);
    };


    config.title = null;

    let emptyChartDivStyle = {
      textAlign: "center",
      fontSize:"12pt",
      fontFamily:'Open Sans'
    };

    let emptyChartStyle = {
      paddingTop:'20px',
      color:'gray',
      fontSize: "16pt"
    };

    let chartStyle = {
      marginTop: '0px',
      display: (hide?'none':'')
    }

    this.v = null;

    if (!hide)
      this.v = <div id="chartId" style={emptyChartDivStyle}> <span className="fa fa-bar-chart" style={emptyChartStyle}><div style={emptyChartDivStyle}>{formatMessage({id:'emptyChart'})}</div></span></div>;

    if (config && config.series.length>0) {
      this.v=(

            <MapsChart ref="chartRef" container="chartId" key="12" options={config} style={chartStyle} />

      );
    }


  return (
    <div>{this.v}</div>
  );
}
}


Chart.PropTypes = {
    config: PropTypes.object.isRequired,
}

export default injectIntl(Chart, {withRef:true});



// WEBPACK FOOTER //
// ./src/components/Chart.js